var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPokeball(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 744.09 1052.4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -1500,
    x2: -1420,
    y1: 892.36,
    y2: 1312.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f00",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -0.036,
    y: -0.036,
    width: 1.072,
    height: 1.072,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.9969831
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1872.7 -633.9)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1500.6,
    cy: 1160.1,
    r: 189.97,
    strokeWidth: 2.8496
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.5 960.18c-105.47 0-191.86 81.641-199.45 185.17h109.14a92.058 92.058 0 0 1 90.816-77.232 92.058 92.058 0 0 1 90.777 77.564h0.072v-0.332h107.91c-8.6743-90.194-94.566-185.17-199.26-185.17z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.6 1091.9a68.141 68.141 0 0 0-68.141 68.141 68.141 68.141 0 0 0 68.141 68.143 68.141 68.141 0 0 0 68.141-68.143 68.141 68.141 0 0 0-68.141-68.141zm0 43.49a24.651 24.651 0 0 1 24.652 24.65 24.651 24.651 0 0 1-24.652 24.652 24.651 24.651 0 0 1-24.65-24.652 24.651 24.651 0 0 1 24.65-24.65z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1700.5 1165.6c2.9823 107.85 91.345 194.37 199.92 194.37 108.26 0 196.42-101.56 199.88-194.37h-107.52a92.058 92.058 0 0 1-91.861 86.428 92.058 92.058 0 0 1-91.775-86.428h-108.65z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.5 960.18c-105.47 0-191.86 81.641-199.45 185.17h109.14a92.058 92.058 0 0 1 90.816-77.232 92.058 92.058 0 0 1 90.777 77.564h0.072v-0.332h107.91c-8.6743-90.194-94.566-185.17-199.26-185.17z",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1872.7 -633.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1500.6,
    cy: 1160.1,
    r: 189.97,
    strokeWidth: 2.8496
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.5 960.18c-105.47 0-191.86 81.641-199.45 185.17h109.14a92.058 92.058 0 0 1 90.816-77.232 92.058 92.058 0 0 1 90.777 77.564h0.072v-0.332h107.91c-8.6743-90.194-94.566-185.17-199.26-185.17z",
    fill: "#f00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.6 1091.9a68.141 68.141 0 0 0-68.141 68.141 68.141 68.141 0 0 0 68.141 68.143 68.141 68.141 0 0 0 68.141-68.143 68.141 68.141 0 0 0-68.141-68.141zm0 43.49a24.651 24.651 0 0 1 24.652 24.65 24.651 24.651 0 0 1-24.652 24.652 24.651 24.651 0 0 1-24.65-24.652 24.651 24.651 0 0 1 24.65-24.65z",
    fill: "#f2f2f2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1700.5 1165.6c2.9823 107.85 91.345 194.37 199.92 194.37 108.26 0 196.42-101.56 199.88-194.37h-107.52a92.058 92.058 0 0 1-91.861 86.428 92.058 92.058 0 0 1-91.775-86.428h-108.65z",
    fill: "#f9f9f9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1500.5 960.18c-105.47 0-191.86 81.641-199.45 185.17h109.14a92.058 92.058 0 0 1 90.816-77.232 92.058 92.058 0 0 1 90.777 77.564h0.072v-0.332h107.91c-8.6743-90.194-94.566-185.17-199.26-185.17z",
    fill: "url(#a)",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.ec7f3f903e8c2e73b72313fd179a52fc.svg";
export { ForwardRef as ReactComponent };